var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn-toggle',{attrs:{"borderless":"","value":_vm.value,"color":"primary","mandatory":""},on:{"change":function($event){return _vm.$emit('input', $event)}}},[_c('v-btn',{attrs:{"value":0}},[_vm._v("Statut & date")]),_c('v-btn',{attrs:{"value":1}},[_vm._v("Nom")]),_c('v-btn',{attrs:{"value":2}},[_vm._v("Type")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }